/* tslint:disable */
/* eslint-disable */
/**
 * Ship to ship api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConfigurationParametersSchema } from './ConfigurationParametersSchema';
import {
    ConfigurationParametersSchemaFromJSON,
    ConfigurationParametersSchemaFromJSONTyped,
    ConfigurationParametersSchemaToJSON,
} from './ConfigurationParametersSchema';

/**
 * Response schema for the configuration resource.
 * Both shape_uuid and geometry can be present (geometry is resolved from shape_uuid).
 * @export
 * @interface ConfigurationResponseSchema
 */
export interface ConfigurationResponseSchema {
    /**
     * Unique identifier for the record
     * @type {number}
     * @memberof ConfigurationResponseSchema
     */
    id?: number | null;
    /**
     * Universal unique identifier for the record
     * @type {string}
     * @memberof ConfigurationResponseSchema
     */
    uuid?: string | null;
    /**
     * Created at this point in time
     * @type {Date}
     * @memberof ConfigurationResponseSchema
     */
    createdAt?: Date | null;
    /**
     * Created by this user
     * @type {string}
     * @memberof ConfigurationResponseSchema
     */
    createdBy?: string | null;
    /**
     * Modified at this point in time
     * @type {Date}
     * @memberof ConfigurationResponseSchema
     */
    modifiedAt?: Date | null;
    /**
     * Modified by this user
     * @type {string}
     * @memberof ConfigurationResponseSchema
     */
    modifiedBy?: string | null;
    /**
     * Name of the configuration
     * @type {string}
     * @memberof ConfigurationResponseSchema
     */
    name: string;
    /**
     * Whether the configuration is enabled
     * @type {boolean}
     * @memberof ConfigurationResponseSchema
     */
    enabled?: boolean;
    /**
     * 
     * @type {ConfigurationParametersSchema}
     * @memberof ConfigurationResponseSchema
     */
    parameters: ConfigurationParametersSchema;
    /**
     * Severity level
     * @type {string}
     * @memberof ConfigurationResponseSchema
     */
    severity?: string;
    /**
     * UUID reference to a shape
     * @type {string}
     * @memberof ConfigurationResponseSchema
     */
    shapeUuid?: string | null;
    /**
     * Geojson data of the configuration
     * @type {{ [key: string]: any; }}
     * @memberof ConfigurationResponseSchema
     */
    geometry?: { [key: string]: any; } | null;
    /**
     * Access control list (read)
     * @type {Array<string>}
     * @memberof ConfigurationResponseSchema
     */
    acl?: Array<string>;
    /**
     * Access control list (write)
     * @type {Array<string>}
     * @memberof ConfigurationResponseSchema
     */
    aclPut?: Array<string>;
    /**
     * Configuration type
     * @type {string}
     * @memberof ConfigurationResponseSchema
     */
    type?: string;
    /**
     * Phone numbers for notifications
     * @type {Array<string>}
     * @memberof ConfigurationResponseSchema
     */
    phoneNumbers?: Array<string>;
    /**
     * Email addresses for notifications
     * @type {Array<string>}
     * @memberof ConfigurationResponseSchema
     */
    emailAddresses?: Array<string>;
    /**
     * Whether to exclude port areas from the configuration geometry
     * @type {boolean}
     * @memberof ConfigurationResponseSchema
     */
    excludePorts?: boolean;
}

/**
 * Check if a given object implements the ConfigurationResponseSchema interface.
 */
export function instanceOfConfigurationResponseSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "parameters" in value;

    return isInstance;
}

export function ConfigurationResponseSchemaFromJSON(json: any): ConfigurationResponseSchema {
    return ConfigurationResponseSchemaFromJSONTyped(json, false);
}

export function ConfigurationResponseSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationResponseSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
        'createdAt': !exists(json, 'created_at') ? undefined : (json['created_at'] === null ? null : new Date(json['created_at'])),
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
        'modifiedAt': !exists(json, 'modified_at') ? undefined : (json['modified_at'] === null ? null : new Date(json['modified_at'])),
        'modifiedBy': !exists(json, 'modified_by') ? undefined : json['modified_by'],
        'name': json['name'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'parameters': ConfigurationParametersSchemaFromJSON(json['parameters']),
        'severity': !exists(json, 'severity') ? undefined : json['severity'],
        'shapeUuid': !exists(json, 'shape_uuid') ? undefined : json['shape_uuid'],
        'geometry': !exists(json, 'geometry') ? undefined : json['geometry'],
        'acl': !exists(json, 'acl') ? undefined : json['acl'],
        'aclPut': !exists(json, 'acl_put') ? undefined : json['acl_put'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'phoneNumbers': !exists(json, 'phone_numbers') ? undefined : json['phone_numbers'],
        'emailAddresses': !exists(json, 'email_addresses') ? undefined : json['email_addresses'],
        'excludePorts': !exists(json, 'exclude_ports') ? undefined : json['exclude_ports'],
    };
}

export function ConfigurationResponseSchemaToJSON(value?: ConfigurationResponseSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'uuid': value.uuid,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt === null ? null : value.createdAt.toISOString()),
        'created_by': value.createdBy,
        'modified_at': value.modifiedAt === undefined ? undefined : (value.modifiedAt === null ? null : value.modifiedAt.toISOString()),
        'modified_by': value.modifiedBy,
        'name': value.name,
        'enabled': value.enabled,
        'parameters': ConfigurationParametersSchemaToJSON(value.parameters),
        'severity': value.severity,
        'shape_uuid': value.shapeUuid,
        'geometry': value.geometry,
        'acl': value.acl,
        'acl_put': value.aclPut,
        'type': value.type,
        'phone_numbers': value.phoneNumbers,
        'email_addresses': value.emailAddresses,
        'exclude_ports': value.excludePorts,
    };
}

